import Modal from "common/Modal/Modal";
import EditTradeInput from "features/trades/EditTrade/EditTradeInput";
import useKeyPressWithCallback from "utils/hooks/useKeyPressWithCallback";
import { EditOrderModalProps } from "@shared/features/trades/EditTrade/types";
import useAddOrEditOrderModal from "@shared/features/trades/EditTrade/useAddOrEditOrderModal";

const AddOrEditOrderModal = ({
  closeModal,
  title,
  orderType,
  order,
  onOk,
}: EditOrderModalProps) => {
  const { onOkClick, priceInputData, secondInputData, isError } =
    useAddOrEditOrderModal({ order, orderType, onOk, closeModal });

  useKeyPressWithCallback("Enter", isError ? undefined : onOkClick);

  return (
    <Modal
      open={true}
      destroyOnHidden={true}
      onCancel={closeModal}
      centered={true}
      closable={false}
      title={title}
      onOk={onOkClick}
      okButtonProps={{
        disabled: isError,
      }}
    >
      <EditTradeInput {...priceInputData} />
      {secondInputData && <EditTradeInput {...secondInputData} />}
    </Modal>
  );
};

export default AddOrEditOrderModal;
